import ActionTypes from "./ActionTypes";

const getUpComingEvents = (payload) => {
  return {
    type: ActionTypes.UPCOMING_EVENTS,
    payload,
  };
};
const getEventHistory = (payload) => {
  return {
    type: ActionTypes.EVENTS_HISTORY,
    payload,
  };
};
const getEventDetail = (payload) => {
  return {
    type: ActionTypes.EVENT_DETAIL,
    payload,
  };
};

const updateEvent = (payload) => {
  return {
    type: ActionTypes.UPDATE_EVENT,
    payload,
  };
};

const editEvent = (payload) => {
  return {
    type: ActionTypes.EDIT_EVENT,
    payload,
  };
};

const deleteEvent = (payload) => {
  return {
    type: ActionTypes.DELETE_EVENT,
    payload,
  };
};

const getBudget = (payload) => {
  return {
    type: ActionTypes.EVENT_BUDGET,
    payload,
  };
};

const getBudgetCat = (payload) => {
  return {
    type: ActionTypes.EVENT_BUDGET_CAT,
    payload,
  };
};

const clearEventDetail = () => {
  return {
    type: ActionTypes.CLEAR_DETAIL,
  };
};

const WeeklyChecklist = (payload) => {
  return {
    type: ActionTypes.WEEKLY_CHECKLIST,
    payload,
  };
};

const MonthlyChecklist = (payload) => {
  return {
    type: ActionTypes.MONTHLY_CHECKLIST,
    payload,
  };
};

const allCheckList = (payload) => {
  return {
    type: ActionTypes.ALL_CHECKLIST,
    payload,
  };
};

const clearCheckList = () => {
  return {
    type: ActionTypes.CLEAR_CHECKLIST,
  };
};

const getCalendarCheckList = (payload) => {
  return {
    type: ActionTypes.CALENDAR_CHECKLIST,
    payload,
  };
};

const getEventReminder = (payload) => {
  return {
    type: ActionTypes.GET_EVENT_REMINDER,
    payload,
  };
};

const getEventTimeline = (payload) => {
  return {
    type: ActionTypes.GET_EVENT_TIMELINE,
    payload,
  };
};

const getLiveChannelData = (payload) => {
  return {
    type: ActionTypes.GET_LIVE_CHANNEL_DATA,
    payload,
  };
};

const getClientPlanningForm = (payload) => {
  return {
    type: ActionTypes.GET_CLIENT_PLANNING_FORM,
    payload,
  };
};

const getClientSection = (payload) => {
  return {
    type: ActionTypes.GET_CLIENT_SECTION,
    payload,
  };
};
const getSubClientSection = (payload) => {
  return {
    type: ActionTypes.GET_CLIENT_SUB_SECTION,
    payload,
  };
};

const getClientQuestion = (payload) => {
  return {
    type: ActionTypes.GET_CLIENT_QUESTION,
    payload,
  };
};

const getEventWedWall = (payload) => {
  return {
    type: ActionTypes.GET_WEDING_WALL,
    payload,
  };
};

const getEventWedWeb = (payload) => {
  return {
    type: ActionTypes.GET_WEDING_WEB,
    payload,
  };
};

export {
  getUpComingEvents,
  getEventDetail,
  getEventHistory,
  clearEventDetail,
  updateEvent,
  editEvent,
  deleteEvent,
  getBudget,
  WeeklyChecklist,
  MonthlyChecklist,
  allCheckList,
  clearCheckList,
  getCalendarCheckList,
  getEventReminder,
  getLiveChannelData,
  getClientPlanningForm,
  getClientSection,
  getClientQuestion,
  getBudgetCat,
  getSubClientSection,
  getEventTimeline,
  getEventWedWall,
  getEventWedWeb
};
